import { useTranslation } from 'react-i18next'
import { DialogContent, DialogActions, Button, Typography } from '@mui/material'
import ResponsiveDialog from './ResponsiveDialog'

interface CancelJobDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
  jobId?: string | number
}

export default function CancelJobDialog({ open, onClose, onConfirm }: CancelJobDialogProps) {
  const { t } = useTranslation()
  return (
    <ResponsiveDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ pt: 3 }}>
        <Typography variant="h6" gutterBottom>
          {t('dialogs.cancelJob.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('dialogs.cancelJob.message')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.buttons.cancel')}</Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          sx={{ boxShadow: '0 2px 8px rgba(220,38,38,0.35)' }}
        >
          {t('dialogs.cancelJob.confirm')}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
